// Library Import
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  GridItem,
  Heading,
  Input,
  InputGroup,
  InputLeftElement,
  Select,
  SimpleGrid,
  Stack,
  Text,
  useToast,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

// Icon Imports

// Local Imports
import { addChallenge } from "../../redux/thunks/adminthunk";
import Toasts from "../Toasts";
import { redResetChallengeCreated } from "../../redux/slices/adminSlice";
import { redSetToast } from "../../redux/slices/userSlice";

const Addtask = () => {
  const dispatch = useDispatch();
  const toast = useToast();

  const [challengeName, setChallengeName] = useState("");
  const [challengeDesc, setChallengeDesc] = useState("");
  const [difficultyLev, setDifficultyLev] = useState("");
  const [score, setScore] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [timeDur, setTimeDur] = useState("");
  const [challengeId, setChallengeId] = useState("");
  const [language, setLanguage] = useState("");
  const [tags, setTags] = useState("");

  const { challengeCreated } = useSelector((state) => state.stateAdminReducer);

  const submitChallenge = () => {
    if (
      challengeName &&
      challengeDesc &&
      difficultyLev &&
      score &&
      startDate &&
      endDate &&
      timeDur &&
      challengeId &&
      language &&
      tags
    ) {
      dispatch(
        addChallenge({
          challengeName,
          challengeDesc,
          difficultyLev,
          score,
          startDate,
          endDate,
          timeDur,
          challengeId,
          language,
          tags,
        })
      );
    } else {
      dispatch(redSetToast({ title: "Enter All Delatils", status: "error" }));
    }
  };

  useEffect(() => {
    if (challengeCreated) {
      dispatch(redSetToast({ title: "Challenge created", status: "success" }));

      dispatch(redResetChallengeCreated());
    }
  }, [challengeCreated]);

  return (
    <Flex
      as="main"
      justify="center"
      bg="gray.200"
      align="center"
      w="100%"
      h="100%"
    >
      <Toasts />
      <Flex w="97%" h="95%" borderRadius="20px" p={4} bg="white">
        <Stack
          width="100%"
          bg="white"
          _dark={{
            bg: "#141517",
          }}
          spacing={6}
          p={4}
        >
          <SimpleGrid columns={6} spacing={6}>
            {/* Challenge Name */}
            <FormControl as={GridItem} colSpan={[3]}>
              <FormLabel
                htmlFor="Challenge_Name"
                fontSize="lg"
                fontWeight="lg"
                color="gray.700"
                _dark={{
                  color: "gray.50",
                }}
              >
                Challenge Name
              </FormLabel>
              <Input
                type="text"
                name="Challenge_Name"
                id="Challenge_Name"
                mt={1}
                focusBorderColor="brand.400"
                shadow="sm"
                size="sm"
                w="full"
                rounded="md"
                onChange={(e) => setChallengeName(e.target.value)}
                value={challengeName}
              />
            </FormControl>

            {/* Challenge Description */}
            <FormControl as={GridItem} colSpan={[3]}>
              <FormLabel
                htmlFor="Challenge_Description"
                fontSize="lg"
                fontWeight="lg"
                color="gray.700"
                _dark={{
                  color: "gray.50",
                }}
              >
                Challenge Description
              </FormLabel>
              <Input
                type="text"
                name="Challenge_Description"
                id="Challenge_Description"
                mt={1}
                focusBorderColor="brand.400"
                shadow="sm"
                size="sm"
                w="full"
                rounded="md"
                onChange={(e) => setChallengeDesc(e.target.value)}
                value={challengeDesc}
              />
            </FormControl>

            {/* Difficulty Level */}
            <FormControl as={GridItem} colSpan={[3]}>
              <FormLabel
                htmlFor="Difficulty_Level"
                fontSize="lg"
                fontWeight="lg"
                color="gray.700"
                _dark={{
                  color: "gray.50",
                }}
              >
                Difficulty Level
              </FormLabel>
              <Select
                id="Difficulty_Level"
                name="Difficulty_Level"
                placeholder="Select option"
                mt={1}
                focusBorderColor="brand.400"
                shadow="sm"
                size="sm"
                w="full"
                rounded="md"
                onChange={(e) => setDifficultyLev(e.target.value)}
              >
                <option value="easy">Easy</option>
                <option value="medium">Medium</option>
                <option value="hard">Hard</option>
              </Select>
            </FormControl>

            {/* Score */}
            <FormControl as={GridItem} colSpan={[3]}>
              <FormLabel
                htmlFor="Score"
                fontSize="lg"
                fontWeight="lg"
                color="gray.700"
                _dark={{
                  color: "gray.50",
                }}
              >
                Score
              </FormLabel>
              <Input
                type="text"
                name="Score"
                id="Score"
                mt={1}
                focusBorderColor="brand.400"
                shadow="sm"
                size="sm"
                w="full"
                rounded="md"
                onChange={(e) => setScore(e.target.value)}
                value={score}
              />
            </FormControl>

            {/* Start Date */}
            <FormControl as={GridItem} colSpan={[3]}>
              <FormLabel
                htmlFor="Start_Date"
                fontSize="lg"
                fontWeight="lg"
                color="gray.700"
                _dark={{
                  color: "gray.50",
                }}
              >
                Start Date
              </FormLabel>
              <Input
                type="date"
                name="Start_Date"
                id="Start_Date"
                mt={1}
                focusBorderColor="brand.400"
                shadow="sm"
                size="sm"
                w="full"
                rounded="md"
                onChange={(e) => setStartDate(e.target.value)}
                value={startDate}
              />
            </FormControl>

            {/* End Date */}
            <FormControl as={GridItem} colSpan={[3]}>
              <FormLabel
                htmlFor="End_Date"
                fontSize="lg"
                fontWeight="lg"
                color="gray.700"
                _dark={{
                  color: "gray.50",
                }}
              >
                End Date
              </FormLabel>
              <Input
                type="date"
                name="End_Date"
                id="End_Date"
                mt={1}
                focusBorderColor="brand.400"
                shadow="sm"
                size="sm"
                w="full"
                rounded="md"
                onChange={(e) => setEndDate(e.target.value)}
                value={endDate}
              />
            </FormControl>

            {/* Time Duration */}
            <FormControl as={GridItem} colSpan={[3]}>
              <FormLabel
                htmlFor="Time_Duration"
                fontSize="lg"
                fontWeight="lg"
                color="gray.700"
                _dark={{
                  color: "gray.50",
                }}
              >
                Time Duration{" "}
              </FormLabel>
              <Input
                type="text"
                name="Time_Duration"
                id="Time_Duration"
                mt={1}
                focusBorderColor="brand.400"
                shadow="sm"
                size="sm"
                w="full"
                rounded="md"
                onChange={(e) => setTimeDur(e.target.value)}
                value={timeDur}
              />
            </FormControl>

            {/* Challenge Id */}
            <FormControl as={GridItem} colSpan={[3]}>
              <FormLabel
                htmlFor="Challenge_Id"
                fontSize="lg"
                fontWeight="lg"
                color="gray.700"
                _dark={{
                  color: "gray.50",
                }}
              >
                Challenge Id
              </FormLabel>
              <Input
                type="text"
                name="Challenge_Id"
                id="Challenge_Id"
                mt={1}
                focusBorderColor="brand.400"
                shadow="sm"
                size="sm"
                w="full"
                rounded="md"
                onChange={(e) => setChallengeId(e.target.value)}
                value={challengeId}
              />
            </FormControl>

            {/* Language */}
            <FormControl as={GridItem} colSpan={[3]}>
              <FormLabel
                htmlFor="Language"
                fontSize="lg"
                fontWeight="lg"
                color="gray.700"
                _dark={{
                  color: "gray.50",
                }}
              >
                Language
              </FormLabel>
              <Select
                id="Language"
                name="Difficulty_Level"
                placeholder="Select option"
                mt={1}
                focusBorderColor="brand.400"
                shadow="sm"
                size="sm"
                w="full"
                rounded="md"
                onChange={(e) => setLanguage(e.target.value)}
              >
                <option value="javascript">Javascript</option>
                <option value="python">Python</option>
                <option value="java">Java</option>
              </Select>
            </FormControl>

            {/* Tags */}
            <FormControl as={GridItem} colSpan={[3]}>
              <FormLabel
                htmlFor="Tags"
                fontSize="lg"
                fontWeight="lg"
                color="gray.700"
                _dark={{
                  color: "gray.50",
                }}
              >
                Tags
              </FormLabel>
              <Input
                type="text"
                name="Tags"
                id="Tags"
                mt={1}
                focusBorderColor="brand.400"
                shadow="sm"
                size="sm"
                w="full"
                rounded="md"
                onChange={(e) => setTags(e.target.value)}
                value={tags}
              />
            </FormControl>

            <Button
              colorScheme="green"
              variant="solid"
              _hover={{ bg: "green.800" }}
              _active={{ bg: "green.600" }}
              onClick={submitChallenge}
            >
              Submit Challenge
            </Button>
          </SimpleGrid>
        </Stack>
      </Flex>
    </Flex>
  );
};

export default Addtask;
